import { render } from "./GroupLink.vue?vue&type=template&id=754e91f9"
import script from "./GroupLink.vue?vue&type=script&lang=js"
export * from "./GroupLink.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__